import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { "aria-hidden": "true" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { "aria-hidden": "true" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 7h12m-8 4v5m4-5v5M9 7l1-2h4l1 2m-8 0 1 13h8l1-13" })
], -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(_ctx.b()),
    role: "button",
    tabindex: "0",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRow && _ctx.handleRow(...args))),
    onKeydown: [
      _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleRow && _ctx.handleRow(...args)), ["enter"])),
      _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRow && _ctx.handleRow(...args)), ["prevent"]), ["space"]))
    ]
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('date'))
    }, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.displayedDate), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.displayedTime) + " · №" + _toDisplayString(_ctx.row.id), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('content'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('exchange'))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('amount', { from: true }))
        }, _toDisplayString(_ctx.displayedAmountFrom), 3),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('currency'))
        }, _toDisplayString(_ctx.displayedCurrencyFrom), 3),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('arrow')),
          "aria-hidden": "true"
        }, "→", 2),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('amount', { to: true }))
        }, _toDisplayString(_ctx.displayedAmountTo), 3),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.b('currency'))
        }, _toDisplayString(_ctx.displayedCurrencyTo), 3)
      ], 2),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('details'))
      }, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("Курс")) + " ", 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.displayedExecutionPrice), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.displayedPair), 1)
        ]),
        _hoisted_1,
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("Объем")) + " ", 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.displayedTransactionVolume), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.displayedCurrencyTo), 1)
        ]),
        _hoisted_2,
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("Комиссия")) + " ", 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.displayedCommission), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.displayedCommissionCurrency), 1)
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('stage'))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("Текущий этап")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.displayedStage), 1)
      ], 2)
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.b('status', { tone: _ctx.displayedStatusTone }))
    }, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.displayedStatus)), 1)
    ], 2),
    (_ctx.isRemoveShow)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(_ctx.b('remove')),
          "aria-label": _ctx.$t('Удалить'),
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRemove && _ctx.handleRemove(...args)), ["stop"]))
        }, _hoisted_6, 10, _hoisted_4))
      : _createCommentVNode("", true)
  ], 34))
}